import { render } from "./FollowUpResponses.vue?vue&type=template&id=41504152&scoped=true"
import script from "./FollowUpResponses.vue?vue&type=script&lang=js"
export * from "./FollowUpResponses.vue?vue&type=script&lang=js"

import "./FollowUpResponses.vue?vue&type=style&index=0&id=41504152&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41504152"]])

export default __exports__